var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon discover",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","viewBox":"0 0 20 32"}},[_c('path',{attrs:{"d":"M19.596 13.867h-7.040l1.709-13.861-13.861 18.126h7.040l-1.709 13.861z"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2d7758","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/MobileNavbar/svgs/SvgDiscover.vue
// module id = t27x
// module chunks = 0